import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { PlaybookPage } from "../../../components/playbooks/playbook-page";
import { playbookPageSearchSchema } from "../../../lib/playbooks/page";

/**
 * A playbook's own page (ENG-1067): its header and tabs, and the chat docked beside it while
 * changing. Which chat is docked is in the address (`?chat=`), on every tab, so a reload and Back
 * keep it; the tab is the path below this one.
 */
export const Route = createFileRoute("/_authenticated/_workspace/playbooks/$playbookId")({
  validateSearch: playbookPageSearchSchema,
  component: function PlaybookRoute() {
    const { playbookId } = Route.useParams();
    const { chat, from } = Route.useSearch();
    const navigate = useNavigate();
    return (
      <PlaybookPage
        key={playbookId}
        playbookId={playbookId}
        chat={chat ?? null}
        fromChat={from === "chat"}
        onChat={(next) =>
          // Docking the chat is not a new page: the tab, the open step and the scroll stay.
          void navigate({
            to: ".",
            search: (previous: Record<string, unknown>) => ({
              ...previous,
              chat: next ?? undefined,
              // Closed, nothing is beside the playbook any more.
              from: next ? (previous["from"] as "chat" | undefined) : undefined,
            }),
            replace: true,
            resetScroll: false,
            viewTransition: false,
          })
        }
      >
        <Outlet />
      </PlaybookPage>
    );
  },
});
